import { UploadableDocumentType } from './types';

const uploadableDocumentTypesList: UploadableDocumentType[] = [
  'ACCRE',
  'BIKE_DELIVERY_STATEMENT',
  'CELIBACY_STATEMENT',
  'COMPANY_CERTIFICATE_OF_RESIDENCE',
  'NO_CRIMINAL_CONVICTION_STATEMENT',
  'POWER_OF_ATTORNEY',
];

export default uploadableDocumentTypesList;
